Layout.api = {
    get(url) {
        //axios get man!
    }
};
